module.exports = __webpack_public_path__ + "img/bg02.0de2efde.jpg";